import React from 'react';
import styled from '@emotion/styled';
import { ThemeProvider } from '@emotion/react';
import PropTypes, { InferProps } from 'prop-types';

import { DropdownPanel } from './DropdownPanel';
import ItemRadio from './DropdownMenu/ItemRadio';
import colours, { palette } from '~/utils/colours';
import { grey } from './DropdownMenu/Shared/themes';
import ListItem from './DropdownMenu/Shared/ListItem';
import ItemRadioGroup from './DropdownMenu/ItemRadioGroup';
import ReplaceableComponents from '~/components/higher-order/ReplaceableComponents';
import ItemGroup, {
  components as itemGroupComponents,
} from './DropdownMenu/ItemGroup';

const RootContainer = styled(DropdownPanel)`
  display: flex;
  overflow: hidden;
  color: #a6a6a6;
  background-color: white;
  border-color: 1px solid ${palette.veryLightPink};
  border-radius: 5px;
  font-size: 14px;

  ${itemGroupComponents.Container}:not(:last-child) {
    border-right: 1px solid ${colours.greyLight};
  }
`;

const dropdownMenuPropTypes = {
  className: PropTypes.string,
  components: PropTypes.any,
  theme: PropTypes.any,
};

export type DropdownMenuProps = InferProps<typeof dropdownMenuPropTypes>;

@ReplaceableComponents({
  RootContainer,
})
class DropdownMenu extends React.Component<DropdownMenuProps> {
  static Item: typeof ListItem;
  static ItemGroup: typeof ItemGroup;
  static ItemRadio: typeof ItemRadio;
  static ItemRadioGroup: typeof ItemRadioGroup;

  static propTypes = dropdownMenuPropTypes;

  static defaultProps = {
    theme: grey,
  };

  render() {
    const { RootContainer } = this.props.components;
    const { children, className } = this.props;

    return (
      <ThemeProvider theme={this.getContainerTheme}>
        <RootContainer className={className}>
          <ThemeProvider theme={this.props.theme}>
            <React.Fragment>{children}</React.Fragment>
          </ThemeProvider>
        </RootContainer>
      </ThemeProvider>
    );
  }

  getContainerTheme(theme: any) {
    return (theme || {}).container || theme || grey.container;
  }
}

DropdownMenu.Item = ListItem;
DropdownMenu.ItemGroup = ItemGroup;
DropdownMenu.ItemRadio = ItemRadio;
DropdownMenu.ItemRadioGroup = ItemRadioGroup;

export default DropdownMenu;
